import { API } from 'aws-amplify';
import {
  REACT_APP_BASE_KEY,
  REACT_APP_BASE_NAME,
  REACT_APP_CLIENT_NAME,
} from '../config/settings/environments';
import axios from 'axios';

/**
 * To get kepler data.
 */
export const getKeplerData = async ({ year, month, day }) => {
  const paths = {
    amsa: '/v2/kepler-gps',
    anglo: '/v2/kepler-gps',
    antucoya: '/v2/kepler-gps',
  };
  let path = paths[REACT_APP_CLIENT_NAME] || '/v2/kepler-data';
  if (year && month && day) {
    path = `${path}?year=${year}&month=${month}&day=${day}`;
  }

  const init = {
    headers: {
      'x-api-key': REACT_APP_BASE_KEY,
    },
    response: true,
  };
  const response = await API.get(REACT_APP_BASE_NAME, path, init);

  return {
    url: response.data,
    headers: response.headers,
    request: response.config,
    status: response.status,
  };
};

/**
 * To get kepler data.
 */
export const getKeplerUrl = async ({ url, onProgress }) => {
  const config = {
    headers: {
      'Access-Control-Allow-Headers':
        'x-api-key,Content-Type,X-Amz-Date,X-Amz-Security-Token,Authorization,X-Api-Key,X-Requested-With,Accept,Access-Control-Allow-Methods,Access-Control-Allow-Origin,Access-Control-Allow-Headers',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'DELETE,GET,HEAD,OPTIONS,PATCH,POST,PUT',
      'X-Requested-With': '*',
    },
    onDownloadProgress: progressEvent => {
      if (onProgress) {
        const percent = (progressEvent.loaded / progressEvent.total) * 100;
        onProgress(percent, progressEvent.loaded, progressEvent.total);
      }
    },
  };

  const response = await axios.get(url, config);

  return {
    data: response.data,
    headers: response.headers,
    request: response.config,
    status: response.status,
  };
};
